import { render, staticRenderFns } from "./ContestDetail.vue?vue&type=template&id=055bd4e0&scoped=true"
import script from "./ContestDetail.vue?vue&type=script&lang=js"
export * from "./ContestDetail.vue?vue&type=script&lang=js"
import style0 from "./ContestDetail.vue?vue&type=style&index=0&id=055bd4e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055bd4e0",
  null
  
)

export default component.exports